import { ChannelTypes } from 'redux/reducers/subscriptions';

const getSelectedEventCategory = ({
  eventCategory,
  currentSettings,
  channelTypeNames,
}: any): any => {
  return currentSettings.eventChannels.reduce(
    (
      prev: any[],
      channel: { channelId: ChannelTypes; eventCategories: any }
    ) => {
      if (channel.eventCategories.includes(eventCategory)) {
        prev.push({
          label: channelTypeNames[channel.channelId] as ChannelTypes,
          value: channel.channelId,
        });
      }
      return prev;
    },
    []
  );
};

export default getSelectedEventCategory;
